import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    getSpendback,
    getIsSpendbackLoading,
    getSpendbackErrorMessage
} from './spendbackEntity';
import {
    getSpendback as queryForSpendback
} from './spendbackActions';
import {
    EmvioCard,
    EmvioLoadingSpinner as LoadingSpinner,
    EmvioRow,
    EmvioTwoColumnItem
} from '@nexio/emvio-util-ui';
import {
    spendbackShape
} from '../../utils/propTypes';
import {
    doesPropExistAndHasItChanged,
    spendbackStatusMapper,
    payoutProviderMapper,
    prettifyMoney
} from '@nexio/emvio-util-app';
import { toastIfError } from '../../utils/toast';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import './Spendback.scss';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';

export class Spendback extends Component {
    static propTypes = {
        error: PropTypes.string,
        isSpendbackLoading: PropTypes.bool,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        onGetSpendbackById: PropTypes.func,
        onGoBack: PropTypes.func,
        spendback: spendbackShape,
        onToggleModal: PropTypes.func,
        customAccess: PropTypes.any,
        payoutAccountMap: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetSpendbackById(this.props.match.params.id);
        mixpanel.track('Spendback page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.id')) {
            this.props.onGetSpendbackById(this.props.match.params.id);
        }
    }

    renderSpendbackResult = () => {
        const items = [
            {
                label: 'Spendback Status',
                value: _.startCase(spendbackStatusMapper[_.get(this.props.spendback, 'spendbackStatus')])
            },
            {
                label: 'Spendback Provider Reference Number',
                value: _.get(this.props.spendback, 'providerSpendbackRef')
            },
            {
                label: 'Provider Response',
                value: _.get(this.props.spendback, 'providerResponse')
            }
        ];

        return this.renderCard(items, 'Spendback Results');
    };

    renderSpendbackInfo = () => {
        const items = [
            {
                label: 'Spendback ID',
                value: _.get(this.props.spendback, 'id')
            },
            {
                label: 'Amount',
                value: _.get(this.props.spendback, 'amount') ? prettifyMoney(_.get(this.props.spendback, 'amount')) : null
            },
            {
                label: 'Currency',
                value: _.get(this.props.spendback, 'currencyId')
            },
            {
                label: 'Description',
                value: _.get(this.props.spendback, 'description')
            },
            {
                label: 'Date Attempted',
                value: _.get(this.props.spendback, 'spendbackDate')
            },
            {
                label: 'Spendback Reference',
                value: _.get(this.props.spendback, 'spendbackRef')
            },
            {
                label: 'Payout Account ID',
                value: _.get(this.props.spendback, 'payoutAccountId')
            },
            {
                label: 'Payout Account Name',
                value: this.props.payoutAccountMap[_.get(this.props.spendback, 'payoutAccountId')]
            }
        ];

        return this.renderCard(items, 'Spendback Information');
    };

    renderRecipient = () => {
        const items = [
            {
                label: 'Recipient ID',
                value: _.get(this.props.spendback, 'recipientId')
            },
            {
                label: 'Recipient Reference Number',
                value: _.get(this.props.spendback, 'recipientRef')
            },
            {
                label: 'Email',
                value: _.get(this.props.spendback, 'email')
            },
            {
                label: 'First Name',
                value: _.get(this.props.spendback, 'firstName')
            },
            {
                label: 'Last Name',
                value: _.get(this.props.spendback, 'lastName')
            },
            {
                label: 'Address Line 1',
                value: _.get(this.props.spendback, 'addressLine1')
            },
            {
                label: 'Address Line 2',
                value: _.get(this.props.spendback, 'addressLine2')
            },
            {
                label: 'City',
                value: _.get(this.props.spendback, 'city')
            },
            {
                label: 'State / Region',
                value: _.get(this.props.spendback, 'region')
            },
            {
                label: 'Postal Code',
                value: _.get(this.props.spendback, 'postalCode')
            },
            {
                label: 'Country',
                value: _.get(this.props.spendback, 'country')
            },
            {
                label: 'Phone Number',
                value: _.get(this.props.spendback, 'phoneNumber')
            },
            {
                label: 'Mobile Number',
                value: _.get(this.props.spendback, 'mobileNumber')
            }
        ];

        return this.renderCard(items, 'Recipient');
    };

    renderProvider = () => {
        const items = [
            {
                label: 'Provider ID',
                value: _.get(this.props.spendback, 'providerId')
            },
            {
                label: 'Provider Type',
                value: _.startCase(payoutProviderMapper[_.get(this.props.spendback, 'providerType')])
            },
            {
                label: 'Provider Recipient Reference Number',
                value: _.get(this.props.spendback, 'providerRecipientRef')
            }
        ];

        return this.renderCard(items, 'Provider');
    };

    renderCard(items, headerTitle) {
        if (items.some((item) => (item.value))) {
            return (
                <EmvioCard className="half-width grow-height" HeaderComponent={headerTitle}>
                    {items.map((item) =>
                        <EmvioTwoColumnItem
                            key={item.label}
                            alterMethod={item.alterMethod}
                            label={item.label}
                            value={item.value}
                            breakAll={item.breakAll}
                        />
                    )}
                </EmvioCard>);
        } else {
            return null;
        }
    }

    render() {
        if (this.props.isSpendbackLoading) {
            return (<LoadingSpinner />);
        } else if (this.props.spendback && this.props.payoutAccountMap && !this.props.error) {

            let cards = [];
            cards.push(this.renderSpendbackResult());
            cards.push(this.renderSpendbackInfo());
            cards.push(this.renderRecipient());
            cards.push(this.renderProvider());
            cards = _.compact(cards);

            const cardRows = _.chunk(cards, 2).map((cardPair, index) => {
                return (
                    // eslint-disable-next-line @eslint-react/no-array-index-key
                    <EmvioRow key={index}>
                        {cardPair[0]}
                        {cardPair[1]}
                    </EmvioRow>
                );
            });

            return (
                <div className="emvio-spendback">
                    {cardRows}
                </div>
            );
        } else {
            return (
                <div className="emvio-spendback">
                    <EmvioRow>
                        <ErrorCard />
                    </EmvioRow>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        error: getSpendbackErrorMessage(state),
        isSpendbackLoading: getIsSpendbackLoading(state),
        spendback: getSpendback(state),
        payoutAccountMap: getPayoutAccountsMapper(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetSpendbackById: (id) => dispatch(queryForSpendback(id))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Spendback));
